import { configureStore } from '@reduxjs/toolkit';
import userReducer from './auth/user-slice';
import consultantReducer from './features/consultant/consultant-slice';
import candidateReducer from './features/candidate/candidate-slice';
import noteReducer from './features/note/note-slice';
import vacancyReducer from './features/vacancy/vacancies-slice';
import vacancyUidsReducer from './features/vacancy/vacancies-uids-slice';
import relationReducer from './features/relation/relation-slice';
import relationContactReducer from './features/relation-contact/relation-contact-slice';


export const store = configureStore({
  reducer: {
    user: userReducer,
    consultant: consultantReducer,
    candidate: candidateReducer,
    notes: noteReducer,
    vacancies: vacancyReducer,
    vacancyUids: vacancyUidsReducer,
    relation: relationReducer,
    relationContact: relationContactReducer,
    
    // other reducers can go here
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;